import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import * as DataFormat from '../../../../../../Common/Scripts';
import * as Helpers from '../../../../../ContractManagement/Markers/Datatables/Helpers/DatatableHelpers';
import { dateEditRenderer, checkboxEditRenderer } from '../../../../../ContractManagement/Markers/Datatables/Helpers/Editors';

const releaseContractFormatter = cell => (cell ? 'Yes' : '');

const swapFormatter = cell => (cell ? 'swap' : '');

const validateDate = newValue => {
	let message = '';
	let error = false;
	const valid = Helpers.isTodayOrFuture(newValue);
	if (!valid) {
		message = 'enter today or future date';
		error = true;
	}
	return { message, error };
};

const AppointeesColumns = onStartEdit => [
	{
		dataField: 'code_name',
		text: 'code_name',
		hidden: true,
		csvExport: false
	},
	{
		dataField: 'qualYear',
		text: 'Qualification Year',
		hidden: true
	},
	{
		dataField: 'apptType',
		text: 'Appointment Type',
		hidden: true
	},
	{
		dataField: 'teamTitle',
		text: 'Marking Team Title',
		hidden: true
	},
	{
		dataField: 'teamCode',
		text: 'Marking Team Code',
		hidden: true,
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'teamId',
		text: 'Team ID',
		hidden: true
	},
	{
		dataField: 'markerCode',
		text: 'Marker Code',
		editable: false,
		headerClasses: 'th-td-sm',
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'name',
		text: 'Name',
		editable: false,
		headerClasses: 'th-td-lg',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'appointmentId',
		text: 'Appointment ID',
		editable: false,
		hidden: true,
		headerClasses: 'th-td-sm'
	},
	{
		dataField: 'niNumber',
		text: 'NI Number',
		editable: false,
		headerClasses: 'th-td-ssmm'
	},
	{
		dataField: 'status',
		text: 'Status',
		editable: false,
		headerClasses: 'th-td-ssx'
	},
	{
		dataField: 'swap',
		text: 'Swap',
		editable: false,
		headerClasses: 'th-td-ssx',
		formatter: swapFormatter,
		csvFormatter: swapFormatter
	},
	{
		dataField: 'releaseContract',
		text: 'Release the Contract',
		editable: true,
		headerClasses: 'th-td-smm',
		editorRenderer: checkboxEditRenderer(onStartEdit),
		formatter: releaseContractFormatter,
		csvFormatter: releaseContractFormatter
	},
	{
		dataField: 'releaseDate',
		text: 'Release Date',
		editable: true,
		headerClasses: 'th-td-ml',
		formatter: Helpers.formatDateInput,
		editorRenderer: dateEditRenderer(onStartEdit, 'Release Date', validateDate),
		validator: newValue => {
			const valid = Helpers.isTodayOrFuture(newValue);
			if (!valid) {
				const message = 'Date needs to be today or in future';
				return { valid, message };
			}
			return true;
		},
		csvFormatter: cell => Helpers.formatDateInput(cell)
	},
	{
		dataField: 'processingIssue',
		text: 'Processing Issue',
		editable: false,
		headerClasses: 'th-td-xxss'
	}
];

export const keyField = 'code_name';
export default AppointeesColumns;
